export default __webpack_public_path__ + "locales/pl/SingleSignOn.json?hash=715e0addeed70a65c87c63af2a1b68d1";